import { render, staticRenderFns } from "./DMultiImageUploadEditor.vue?vue&type=template&id=122ca1e3&"
import script from "./DMultiImageUploadEditor.vue?vue&type=script&lang=js&"
export * from "./DMultiImageUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./DMultiImageUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports